module.exports = __webpack_public_path__ + "static/img/brees-2010-top-image-thumb.2d2d48a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-top-image-thumb.jpg
// module id = S1WP
// module chunks = 1